import {useEffect,  useState}from 'react'
import { Table,Space,Flex, App, Modal } from 'antd';
import { useYhDelMutation, useYhListQuery } from '../../store/BnsKeJiApi';
import ModalDel from '../../cpn/ModalDel';
import ClientAdd from './ClientAdd';
import ClientEdit from './ClientEdit';
import { SettingOutlined } from '@ant-design/icons';
function ClientList(props) {  
    const {message} = App.useApp()
    const eu_id = JSON.parse(localStorage.getItem('eu_id'))
    const eu_name = JSON.parse(localStorage.getItem('eu_name'))
    const [list, setList] = useState(); 
    const {data, isSuccess} = useYhListQuery({yh_xm_id:props.bxm_id},{refetchOnMountOrArgChange:1});    
    useEffect(() => {
        if (isSuccess) {
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {yh_id:key,yh_name,yh_ctime,yh_uname,yh_content,yh_bxm_name,yh_bxm_id} = item;
                    return item = {key,yh_name,yh_ctime,yh_uname,yh_content,yh_bxm_name,yh_bxm_id}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.yh_ctime;
                    let bTimeString = b.yh_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])  
    const columns = [
        {
            key: 'yh_name',
            title: '客户端',
            dataIndex: 'yh_name',            
        }, 
        {
            key: 'yh_content',
            title: '备注',
            dataIndex: 'yh_content',            
        },          
       
        {
            key: 'num',
            title: '编号',            
            dataIndex: 'key',           
        },
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>{record.yh_ctime + record.yh_uname}</>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>  
                        <ClientEdit yh_id={record.key} bxm_id={props.bxm_id} bxm_name={props.bxm_name} eu_id={eu_id} eu_name={eu_name}/>
                        <ModalDel onOk={() => {
                                                del({yh_id:record.key}).then((res) => {
                                                    console.log(res);
                                                    if (res.data.Status === 'success') {
                                                        message.success('删除成功！')                                                                              
                                                    }
                                                    if (res.data.Status === 'fail') {
                                                        message.error('删除失败！'+res.data.Message)
                                                    }
                                                })
                                            }} />                         
                    </Space>
                </>
            }
        },
    ]   
    //删除
    const [del] = useYhDelMutation()
    const [open, setOpen] = useState(false);
    return (
        <>  
            <a onClick={() => { setOpen(true) }}><SettingOutlined /> 客户端设置</a>
            <Modal
                open={open}
                width={1000}
                title={props.bxm_name + " - 客户端设置"}
                onCancel={() => { setOpen(false); }}
            >
                <Flex justify='flex-end'>
                    <ClientAdd eu_id={eu_id} eu_name={eu_name} bxm_id={props.bxm_id} bxm_name={props.bxm_name}/>
                </Flex>       
                <Table 
                    columns={columns} 
                    dataSource={list} 
                    style={{marginTop:"20px"}}
                    pagination={{showSizeChanger:true,defaultPageSize:'50',showTotal:(total) => `共${total}条`}}                 
                />
            </Modal>
        </>
    )
}

export default ClientList
